import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { brandIsSet } from './useSalonBrand'
import { hapticTick } from '../../../../_utils/haptics'
import './BrandCard.css'

// Campaigns hub: until the salon has a brand, one quiet line pointing at
// Your brand (Back comes back here). Gone for good once the brand is saved
// or it's dismissed.

const DISMISS_KEY = () => `beu-brand-nudge-dismissed-${localStorage.getItem('salonId') || 'me'}`

const readDismissed = () => {
  try { return localStorage.getItem(DISMISS_KEY()) === '1' } catch (e) { return false }
}

export const BrandNudge = () => {
  const history = useHistory()
  const [hidden, setHidden] = useState(() => brandIsSet() || readDismissed())
  if (hidden) return null

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY(), '1') } catch (e) { /* private mode */ }
    setHidden(true)
  }

  return (
    <div className="brc-nudge" role="note">
      <span className="brc-nudge-dot" aria-hidden />
      <p className="brc-nudge-text">
        <strong>Make every email look like you.</strong> Set your logo, colour and type once, and every new email starts with them.
      </p>
      <div className="brc-nudge-actions">
        <button type="button" className="brc-nudge-link" onClick={dismiss}>Not now</button>
        <button type="button" className="brc-nudge-go" onClick={() => { hapticTick(); history.push('/marketing-brand', { from: history.location.pathname }) }}>Set up your brand</button>
      </div>
    </div>
  )
}

export default BrandNudge
